// extracted by mini-css-extract-plugin
module.exports = {"srOnly":"ReadOnlyPanel__srOnly--3URnV","hiddenInput":"ReadOnlyPanel__hiddenInput--2ovwH","root":"ReadOnlyPanel__root--1I2OH","description":"ReadOnlyPanel__description--2CWY6"};